import React, { useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  KnowledgeBinder,
  KnowledgeInfo,
  UserProfilePopup,
  AdmissionBinder,
  LabBinderPage,
} from 'src/pages/application';
import { LabValueInfo } from 'src/pages/application/lab/components';
import { AdmissionChecklistInfo } from '../../pages/application/admission/components';
import { AskPandaChatSwitch } from '../ai';
import styles from './app-layout.module.scss';
import { Header } from './components';
import { Sidebar } from './components/sidebar/sidebar';
import { ViewSelectorProvider } from '../common/view-selector';
import { LoginBubble } from '../../pages/authentication';
import { SkipNavigation, ReturnToTop } from '../common/skip-navigation';
import { FOCUSABLE_SELECTORS } from '../common/items-navigator/navigation.constants';

export function AppLayout({ children }) {
  const mainContentRef = useRef(null);
  const isFirstRender = useRef(true);
  const location = useLocation();

  const focusFirstElement = useCallback(() => {
    if (!mainContentRef.current) return;

    const selector = FOCUSABLE_SELECTORS.join(', ');
    const firstFocusable = mainContentRef.current.querySelector(selector);

    if (firstFocusable) {
      firstFocusable.focus({ preventScroll: true });
    }
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (mainContentRef.current) {
      mainContentRef.current.focus({ preventScroll: true });
    }
  }, [location.pathname]);

  return (
    <ViewSelectorProvider>
      <div className={styles.root}>
        <SkipNavigation onSkip={focusFirstElement} />
        <Header />
        <div className={styles.main}>
          <Sidebar />
          <main id="main-content" className={styles.content} tabIndex="-1" ref={mainContentRef}>
            {children}
          </main>
          <LoginBubble />
          <KnowledgeBinder />
          <KnowledgeInfo />
          <LabBinderPage />
          <LabValueInfo />
          <AdmissionBinder />
          <AdmissionChecklistInfo />
          <UserProfilePopup />
          <AskPandaChatSwitch />
          <ReturnToTop onSkip={focusFirstElement} />
        </div>
      </div>
    </ViewSelectorProvider>
  );
}
